import type { DataEnabledTagValueField } from "@/App/types/twiageTypes";
import { HttpClient } from "@/App/services/httpClient/HttpClient";
import { TagPaths } from "@/Pages/Cases/tags/TagPaths";

type TagPayload = {
  caseId: string;
  tagId: string;
};

type AddDataEnabledTagPayload = TagPayload & {
  fields: DataEnabledTagValueField[];
};

export const TagService = {
  addDataEnabledTag({ caseId, tagId, fields }: AddDataEnabledTagPayload): Promise<unknown> {
    return HttpClient.patch({
      path: TagPaths.DATA_ENABLED_TAGS(caseId, tagId),
      body: fields,
    });
  },
};
